import { useMutation, useQueryClient } from '@tanstack/react-query';

import { migrationService, type MigrationPayload } from '@/services/migration.service';

export const useValidateMigration = () =>
  useMutation({
    mutationFn: (payload: MigrationPayload) => migrationService.validate(payload),
  });

// An import adds clients, RMs and renewals, so every cached list is stale.
export const useCommitMigration = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: MigrationPayload) => migrationService.commit(payload),
    onSettled: () => {
      void queryClient.invalidateQueries();
    },
  });
};
